var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 alina-form p-5"},[_vm._v(" Мемориальный комплекс \"Осетровский плацдарм\" "),_c('a',{attrs:{"href":"https://oixm.ru/","target":"_blank"}},[_vm._v(" Острогожского историко-художественного музея им. И.Н. Крамского ")]),_c('br'),_vm._v(" Воронежская область, Верхнемамонский район, 720 км федеральной автомобильной дороги М4 «Дон». ")])
}]

export { render, staticRenderFns }